import { render, staticRenderFns } from "./A320V2.vue?vue&type=template&id=2e49185d&scoped=true&"
import script from "./A320V2.vue?vue&type=script&lang=js&"
export * from "./A320V2.vue?vue&type=script&lang=js&"
import style0 from "./A320V2.vue?vue&type=style&index=0&id=2e49185d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e49185d",
  null
  
)

export default component.exports